// implement combineReducers() that also supports undefined values
export default function (reducers) {
  return (state = {}, action) => {
    return Object.entries(reducers).reduce((result, [key, reducer]) => {
      result[key] = reducer(state[key], action);
      return result;
    }, {});
  };
};